import api from "./api-service";

export const findAllActive = () => api().get("marital-status/active");
